const moduleImages = [];

export {
	moduleImages
};